<template>
  <v-card class="pa-5" flat>
    <v-dialog v-model="novoModelo">
      <v-card class="pa-3">
        <v-layout row justify-space-between wrap>
          <v-flex xs4 class="ma-3">
            <h3 class="fonte text-uppercase mt-2">Template</h3>
            <div class="ma-3">
              <v-img
                src="https://d1ffehxzshl7nv.cloudfront.net/blog/wp-content/uploads/sites/4/2017/09/interactive-notification-e1523282952179.png"
                aspect-ratio="1.0"
                contain
              ></v-img>
              <v-card style="position: fixed; top: 238px; left: 137.8px;">
                <div is="layoutpush" :push.sync="push"></div>
              </v-card>
            </div>
          </v-flex>

          <v-flex xs6 class="ma-3">
            <h3 class="fonte text-uppercase mt-2">Campos</h3>
            <div class="ma-3">
              <v-text-field class="mb-3" label="Link da foto" box v-model="push.logo"></v-text-field>
              <v-text-field class="mb-3" label="Título" box v-model="push.titulo"></v-text-field>
              <v-textarea class="mb-3" label="Mensagem" box v-model="push.mensagem"></v-textarea>
              <v-textarea class="mb-3" label="Link da Imagem" box v-model="push.imagem"></v-textarea>
              <v-text-field class="mb-3" label="Ação do botão" box v-model="push.label"></v-text-field>
            </div>
            <v-btn class="ml-4" round large color="fundo" @click="exibeTemplate">Teste de Layout</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editModelo"></v-dialog>
    <h1 class="fonte text-uppercase">Escolha o template da Notificação</h1>
    <v-btn class="ml-0" color="fundo" @click="novoModelo = true">Novo Modelo</v-btn>
    <!--<v-layout row wrap pt-5>
                <v-flex xs5>
                    <h3>Draggable 1</h3>
                    <v-card class="pa-0 ma-0">
                        <v-layout row  wrap>
                            <v-flex xs2 pa-3 pt-4>
                                <v-avatar size="50" :tile="false" color="grey lighten-4">
                                    <img :src="push.logo" alt="avatar">
                                </v-avatar>
                            </v-flex>
                            <v-flex xs9 pa-3>
                                <div class="pb-3">
                                    <div class="headline">{{push.titulo}}</div>
                                    <div style="height: 150px; overflow: auto;">
                                        <span class="grey--text text--lighten-1">{{push.mensagem}}</span>
                                        <draggable class="list-group" :list="push.imagem" group="people" @change="log">
                                                <v-img v-for="(e, i) in push.imagem" :key="i" :src="e" aspect-ratio="1.7"></v-img>
                                        </draggable>
                                    </div>
                                </div>
                                <v-divider></v-divider>
                                <v-btn flat class="ma-0 mt-3" block>{{push.label}}</v-btn>
                            </v-flex>
                        </v-layout>


                    </v-card>

                </v-flex>
                <v-flex xs1></v-flex>
                <v-flex xs5>
                    <h3>Draggable 2</h3>

                    <v-card>
                        <v-container grid-list-sm fluid>
                        <v-layout row wrap>
                            <v-flex
                            v-for="(e, i) in imagens"
                            :key="i"
                            xs4
                            d-flex
                            >
                            <v-card flat tile class="d-flex">
                                <draggable class="list-group" :list="imagens" group="people" @change="log">
                                        <v-img
                                        :src="e"
                                        :lazy-src="e"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                        >
                                        <template v-slot:placeholder>
                                            <v-layout
                                            fill-height
                                            align-center
                                            justify-center
                                            ma-0
                                            >
                                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                            </v-layout>
                                        </template>
                                        </v-img>
                                </draggable>

                            </v-card>
                            </v-flex>
                        </v-layout>
                        </v-container>
                    </v-card>

                </v-flex>
    </v-layout>-->
  </v-card>
</template>

<script>
import draggable from "vuedraggable";
import layoutpush from "./layout/layoutpush.vue";
export default {
  components: {
    layoutpush,
    draggable
  },
  data() {
    return {
      novoModelo: false,
      editModelo: false,
      push: {
        logo: "https://vuetifyjs.com/apple-touch-icon-180x180.png",
        imagem:
          "https://cdn.awsli.com.br/239/239279/produto/7077161/painel-para-decoracao-de-festa-infantil-homem-de-ferro-204dd9f7.jpg",
        titulo: "Teste",
        mensagem:
          "Integer venenatis venenatis purus, feugiat posuere nisl bibendum quis.",
        label: "Clique aqui"
      },
      imagens: [
        "https://cdn.awsli.com.br/239/239279/produto/7077161/painel-para-decoracao-de-festa-infantil-homem-de-ferro-204dd9f7.jpg",
        "https://img.elo7.com.br/product/zoom/2442E76/homem-de-ferro-painel-lona-grande-2-00x1-50cm-festa-infantil-banner-personalizado.jpg",
        "https://a-static.besthdwallpaper.com/avengers-endgame-filme-powers-homem-de-ferro-papel-de-parede-17966_L.jpg"
      ],
      list1: [
        { name: "John", id: 1 },
        { name: "Joao", id: 2 },
        { name: "Jean", id: 3 },
        { name: "Gerard", id: 4 }
      ],
      list2: [
        { name: "Juan", id: 5 },
        { name: "Edgard", id: 6 },
        { name: "Johnson", id: 7 }
      ]
    };
  },
  methods: {
    exibeTemplate() {
      //console.log(this.push);
    },
    add: function() {
      this.list.push({ name: "Juan" });
    },
    replace: function() {
      this.list = [{ name: "Edgard" }];
    },
    clone: function(el) {
      return {
        name: el.name + " cloned"
      };
    },
    log: function(evt) {
      window.console.log(evt);
    }
  }
};
</script>

<style>
.mobile {
  background: url("https://d1ffehxzshl7nv.cloudfront.net/blog/wp-content/uploads/sites/4/2017/09/interactive-notification-e1523282952179.png")
    no-repeat;
  width: 500px;
  height: 400px;
}
</style>





// WEBPACK FOOTER //
// src/components/user/push/TemplatesNotificacaoPush.vue